import { TachoDriverStatus } from "../../../ducks/data/tracker-devices";
import { secondsToHoursMinutes } from "../components/seconds-to-hours-minutes";
// import { useL10n } from "../../../l10n";
// import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

const DriverTachoStats = ({ stats }: { stats: TachoDriverStatus }) => {
  // const l10n = useL10n();
  // const formatDate = l10n.formatDateAndTime.bind(l10n);
  const { t } = useTranslation("liveView");

  return (
    <div className="grid grid-cols-2 gap-x-2 font-normal mt-2">
      {/*{stats.continuousDrivingDuration && (*/}
      {/*  <>*/}
      {/*    <div>Continuous driving duration:</div>*/}
      {/*    <div> {secondsToHoursMinutes(stats.continuousDrivingDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.cumulativeBreakDuration && (*/}
      {/*  <>*/}
      {/*    <div>Cumulative break duration:</div>*/}
      {/*    <div> {secondsToHoursMinutes(stats.cumulativeBreakDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.cumulativeDrivingDuration && (*/}
      {/*  <>*/}
      {/*    <div>Cumulative driving duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.cumulativeDrivingDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.selectedActivityDuration && (*/}
      {/*  <>*/}
      {/*    <div>Selected activity duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.selectedActivityDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {stats.workState && (
        <>
          <div>{t("tachoStats.workState")}:</div>
          <div>{stats.workState}</div>
        </>
      )}
      {/*{stats.timeState && (*/}
      {/*  <>*/}
      {/*    <div>Time state:</div>*/}
      {/*    <div>{stats.timeState}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {stats.dailyBeforeRestDuration && (
        <>
          <div>{t("tachoStats.dailyBeforeRestDuration")}:</div>
          <div>{secondsToHoursMinutes(stats.dailyBeforeRestDuration)}</div>
        </>
      )}
      {/*{stats.dailyDrivingDuration && (*/}
      {/*  <>*/}
      {/*    <div>Daily driving duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.dailyDrivingDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.dailyLimitExceedNumber && (*/}
      {/*<>*/}
      {/*  <div>Daily limit exceed number:</div>*/}
      {/*  <div>{stats.dailyLimitExceedNumber}</div>*/}
      {/*</>*/}
      {/*)}*/}
      {/*{stats.dailyMinimumRestDuration && (*/}
      {/*  <>*/}
      {/*    <div>Daily minimum rest duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.dailyMinimumRestDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.dailyRestEndTimestamp && (*/}
      {/*  <>*/}
      {/*    <div>Daily rest end timestamp:</div>*/}
      {/*    <div>*/}
      {/*      {formatDate(DateTime.fromMillis(stats.dailyRestEndTimestamp))}*/}
      {/*    </div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.multiManningStatus && (*/}
      {/*  <>*/}
      {/*    <div>Multi manning status:</div>*/}
      {/*    <div>True</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.nextDrivingDuration && (*/}
      {/*  <>*/}
      {/*    <div>Next driving duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.nextDrivingDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.nextRestDuration && (*/}
      {/*  <>*/}
      {/*    <div>Next rest duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.nextRestDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.remainingBeforeRestDuration && (*/}
      {/*  <>*/}
      {/*    <div>Remaining before rest duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.remainingBeforeRestDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {stats.remainingCurrentDrivingDuration && (
        <>
          <div>{t("tachoStats.remainingCurrentDrivingDuration")}:</div>
          <div>
            {secondsToHoursMinutes(stats.remainingCurrentDrivingDuration)}
          </div>
        </>
      )}
      {stats.remainingCurrentRestDuration && (
        <>
          <div>{t("tachoStats.remainingCurrentRestDuration")}:</div>
          <div>{secondsToHoursMinutes(stats.remainingCurrentRestDuration)}</div>
        </>
      )}
      <>
        <div>{t("tachoStats.remainingReducedDailyRestPeriods")}:</div>
        <div>{stats.remainingReducedDailyRestPeriods}</div>
      </>
      <>
        <div>{t("tachoStats.remainingTenHourDrivingTimes")}:</div>
        <div>{stats.remainingTenHourDrivingTimes}</div>
      </>
      {stats.remainingWeeklyDrivingDuration && (
        <>
          <div>{t("tachoStats.remainingWeeklyDrivingDuration")}:</div>
          <div>
            {secondsToHoursMinutes(stats.remainingWeeklyDrivingDuration)}
          </div>
        </>
      )}
      {/*{stats.timeUntilNextDriving && (*/}
      {/*  <>*/}
      {/*    <div>Time until next driving:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.timeUntilNextDriving)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {stats.weeklyBeforeRestDuration && (
        <>
          <div>{t("tachoStats.weeklyBeforeRestDuration")}:</div>
          <div>{secondsToHoursMinutes(stats.weeklyBeforeRestDuration)}</div>
        </>
      )}
      {/*{stats.weeklyDrivingDuration && (*/}
      {/*  <>*/}
      {/*    <div>Weekly driving duration:</div>*/}
      {/*    <div>{secondsToHoursMinutes(stats.weeklyDrivingDuration)}</div>*/}
      {/*  </>*/}
      {/*)}*/}
      {stats.weeklyMinimumRestDuration && (
        <>
          <div>{t("tachoStats.weeklyMinimumRestDuration")}:</div>
          <div>{secondsToHoursMinutes(stats.weeklyMinimumRestDuration)}</div>
        </>
      )}
      {/*{stats.weeklyRestEndTimestamp && (*/}
      {/*  <>*/}
      {/*    <div>Weekly rest end timestamp:</div>*/}
      {/*    <div>*/}
      {/*      {formatDate(DateTime.fromMillis(stats.weeklyRestEndTimestamp))}*/}
      {/*    </div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.weeklySecondRestEndTimestamp && (*/}
      {/*  <>*/}
      {/*    <div>Weekly second rest end timestamp:</div>*/}
      {/*    <div>*/}
      {/*      {formatDate(*/}
      {/*        DateTime.fromMillis(stats.weeklySecondRestEndTimestamp)*/}
      {/*      )}*/}
      {/*    </div>*/}
      {/*  </>*/}
      {/*)}*/}
      {/*{stats.workStateEnum && (*/}
      {/*  <>*/}
      {/*    <div>Work state enum:</div>*/}
      {/*    <div>{stats.workStateEnum}</div>*/}
      {/*  </>*/}
      {/*)}*/}
    </div>
  );
};

export default DriverTachoStats;
